var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',{attrs:{"id":"window_portal"}},[_vm._t("default",null,{"window":_vm.windowRef})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }